import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-slide-edit-free-form-line',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-line.component.html',
    styleUrls: ['./free-form-line.component.scss'],
    standalone: false
})
export class FreeFormLineComponent {
  readonly FlatModels = FlatModels;
}
